import Marquee from "react-fast-marquee";

const ITEMS = ["Brennholz", "Bauholz", "Forstdienstleistungen", "Holzkunst", "Uckermark", "Berlin", "Mecklenburgische Seenplatte", "Mecklenburg-Strelitz"];

export const EditorialMarquee = () => (
    <div className="border-y border-[#2E2517] bg-[#120E09] py-6" data-testid="editorial-marquee">
        <Marquee speed={30} gradient={false} pauseOnHover>
            {ITEMS.map((item, i) => (
                <span key={i} className="mx-10 flex items-center gap-20">
                    <span className="font-display text-2xl font-extrabold uppercase tracking-wide text-[#9C917D]">
                        {item}
                    </span>
                    <span className="text-2xl" aria-hidden="true">🪵</span>
                </span>
            ))}
        </Marquee>
    </div>
);
